import styled from 'styled-components';
import BannerBG from 'common/assets/image/saasModern/pngwing.png';
import colors from 'common/theme/saasModern/colors';
import { saasModernTheme } from 'common/theme/saasModern';
import Link from 'next/link';

export const BannerComponent = styled.section`
  width: 100%;
  background-image: url(${BannerBG?.src});
  z-index: 1;
  background-size: cover;
  background-repeat: no-repeat;
  padding-top: 184px;
  margin-bottom: 100px;
  position: relative;
  @media (max-width: 950px) {
    padding-top: 110px;
    margin-bottom: 50px;
    padding-bottom: 0;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  align-self: stretch;
  justify-content: center;
  flex-direction: column;
  gap: ${saasModernTheme.space[10]}px;
`;

export const HeadLine = styled.div`
  width: 70%;
  text-align: center;
  margin: 0;
  @media (max-width: 600px) {
    width: 90%;
  }
`;

export const Description = styled.p`
  font-size: 20px;
  font-weight: 400;
  font-family: ${saasModernTheme.fontFamily};
  text-align: center;
  font-style: normal;
  line-height: normal;
  width: 50%;
  color: var(--Text-Secondary, #636f81);
  margin: 0;
  @media (max-width: 1024px) {
    font-size: ${saasModernTheme.space[5]}px;
    width: 70%;
  }
  @media (max-width: 950px) {
    font-size: ${saasModernTheme.space[5]}px;
    width: 60%;
  }
  @media (max-width: 600px) {
    width: 90%;
  }
`;

export const FormSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  max-width: 400px;

  @media (max-width: 650px) {
    width: 100%;
  }
`;

export const ButtonLogoWrapper = styled.div`
  display: flex;
  gap: ${saasModernTheme.space[2]}px;
  margin-top: ${saasModernTheme.space[5]}px;
  @media (max-width: 1024px) {
    align-items: center;
    justify-content: center;
  }
  @media (max-width: 650px) {
    align-items: center;
    flex-direction: column;
  }
`;
export const PrimaryButton = styled.button`
  background: ${saasModernTheme.defaultBackgroundColor};
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  height: 40px;
  padding: 12px 16px;
  justify-content: center;
  display: flex;
  align-items: center;
  font-family: ${saasModernTheme.fontFamily};
  text-decoration: none;

  &:hover {
    background: ${saasModernTheme.customColor.gradiantColor};
  }

  @media (max-width: 650px) {
    width: 100%;
  }
`;

export const SecondaryButton = styled.button`
  background: transparent;
  color: #111927;
  border: none;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 12px;
  cursor: pointer;
  border: 1px solid var(--Outlined-Outlined, rgba(145, 155, 171, 0.24));
  white-space: nowrap;
  font-family: ${saasModernTheme.fontFamily};
  &:hover {
    box-shadow: ${saasModernTheme.gradiantShadow};
  }
  @media (max-width: 650px) {
    width: 100%;
  }
`;

export const PrimaryLink = styled(Link)`
  background: ${saasModernTheme.defaultBackgroundColor};
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  padding: 8px 16px;
  justify-content: center;
  display: flex;
  align-items: center;
  font-family: ${saasModernTheme.fontFamily};
  text-decoration: none;
  &:hover {
    background: ${saasModernTheme.customColor.gradiantColor};
  }
  @media (max-width: 650px) {
    width: 90%;
    margin: 0 auto;
  }
`;

export const SecondaryLink = styled(Link)`
  background: transparent;
  color: #111927;
  border: none;
  padding: 8px 16px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: 1px solid var(--Outlined-Outlined, rgba(145, 155, 171, 0.24));
  white-space: nowrap;
  text-decoration: none;
  font-family: ${saasModernTheme.fontFamily};
  &:hover {
    box-shadow: ${saasModernTheme.gradiantShadow};
  }
  @media (max-width: 650px) {
    width: 90%;
    margin: 0 auto;
  }
`;


export const StyledLink = styled.a`
  text-decoration: none;
  '&:hover': {
    textDecoration: 'none',
  },
`;

export const BannerWrapperNav = styled.div``;
